import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  COMMISSION_DECISION,
  COMMISSION_DECISION_URL,
} from 'SharedDir/backend/endpoints/commissions';
import {
  CommissionDecisionFull,
  CommissionDecisionUpdateIn,
} from 'SharedDir/declarations/commissions';
import { FileFull } from 'SharedDir/declarations/files';

export default class CommissionDecisionsApiClass extends SimpleApi<
  CommissionDecisionFull,
  CommissionDecisionUpdateIn
> {
  constructor() {
    super(COMMISSION_DECISION_URL);
  }

  public async addParagraph(
    commissionDecisionId: number,
    applicationId: number
  ): Promise<CommissionDecisionFull> {
    const { data: raw } = (await http({
      url: `${this.url}/${commissionDecisionId}/${applicationId}`,
      method: 'post',
    })) as AxiosResponse<CommissionDecisionFull>;

    return raw;
  }

  public async removeParagraph(
    commissionDecisionId: number,
    applicationId: number
  ): Promise<CommissionDecisionFull> {
    const { data: raw } = (await http({
      url: `${this.url}/${commissionDecisionId}/${applicationId}`,
      method: 'delete',
    })) as AxiosResponse<CommissionDecisionFull>;

    return raw;
  }

  public async approve(commissionDecisionId: number): Promise<CommissionDecisionFull> {
    const { data: raw } = (await http({
      url: `${this.url}/${commissionDecisionId}/approve`,
      method: 'post',
    })) as AxiosResponse<CommissionDecisionFull>;

    return raw;
  }

  public async generateProtocol(commissionDecisionId: number): Promise<FileFull> {
    const endpoint = COMMISSION_DECISION.GENERATE_PROTOCOL(commissionDecisionId);
    const { data: raw } = (await http({
      method: endpoint.method,
      url: `${this.url}/${commissionDecisionId}/generate-protocol`,
    })) as AxiosResponse<FileFull>;

    return raw;
  }
}
